export default class Estimate {

    constructor($view) {
        this.$view = $view;
        this.$fieldToCalculate = this.$view.find('.calculate');
        this.calculate();
        this.bind();
    }

    bind() {


        // ecoute les fields input
        this.$fieldToCalculate.on('change', (e)=>{
            this.calculate();

        });


        // gere l'affichage des input chiffre d'affaires sur les activités en fonction de ce qui est cliqué
        window.addEventListener("load", function (event) {
            if (window.screen.width < 767) {
                $("#responsiveonly").addClass('show');
                $("#desktoponly").removeClass('show');
            } else {
                $("#responsiveonly").removeClass('show');
                $("#desktoponly").addClass('show');
            }
            // declencher le resize au chargement pr afficher le bon input
            $('#transaction').trigger("change");
            $('#location').trigger("change");
            $('#gestion').trigger("change");
            $('#syndic').trigger("change");
        });


        // on resize
        window.addEventListener("resize", function () {

            if (window.screen.width < 767) {
                $("#responsiveonly").addClass('show');
                $("#desktoponly").removeClass('show');
            } else {
                $("#responsiveonly").removeClass('show');
                $("#desktoponly").addClass('show');
            }

        });

        $('#transaction').on('change', (e) => {
            if ($('#transaction').is(':checked')) {

                $('#transactionall').addClass('show');
                $('#transaction-n-1').prop('required','required');
            } else {

                $('#transaction-n-1').removeProp('required');

                $('#transaction-n-1').val();
                $('#transaction-n-2').val();
                $('#transaction-n-3').val();

                $('#transactionall').removeClass('show');
            }

            this.calculate();
        });

        $('#location').on('change', (e) => {
            if ($('#location').is(':checked')) {
                $('#locationall').addClass('show');
                $('#location-n-1').prop('required','required');
            } else {
                $('#location-n-1').removeProp('required');
                $('#location-n-1').val();
                $('#location-n-2').val();
                $('#location-n-3').val();
                $('#locationall').removeClass('show');
            }

            this.calculate();
        });
        $('#gestion').on('change', (e) => {
            if ($('#gestion').is(':checked')) {
                $('#gestionall').addClass('show');
                $('#gestion-n-1').prop('required','required');
            } else {
                $('#gestion-n-1').removeProp('required');
                $('#gestion-n-1').val();
                $('#gestion-n-2').val();
                $('#gestion-n-3').val();
                $('#gestionall').removeClass('show');
            }
            this.calculate();
        });
        $('#syndic').on('change', (e) => {
            if ($('#syndic').is(':checked')) {
                $('#syndicall').addClass('show');
                $('#syndic-n-1').prop('required','required');
            } else {
                $('#syndic-n-1').removeProp('required');
                $('#syndic-n-1').val();
                $('#syndic-n-2').val();
                $('#syndic-n-3').val();
                $('#syndicall').removeClass('show');
            }
            this.calculate();
        });

        // on ajout un event sur le code postal
        $("#zip").keyup(function (e) {
            var resultInput = e.target.value;
            $.ajax({
                url: "/cities/search",
                data: {
                    autocomplete: resultInput,
                    format: 2,
                    name: 'town',
                    id: 'town'
                },
                success: function (data) {
                    $("#second-ville-container").html(data.html);
                    $("#town").select2();
                },
                error: function () {

                },
            });
        });
    }

    /*
    * Permet le calcul des différents elements de chiffre d'affaires dans estimate
     */
    calculate() {

        var n1 = 0;
        var n2 = 0;
        var n3 = 0;



        if ($('#transaction').is(':checked')) {
            n1 += this.checkTheValue(parseInt($('#transaction-n-1').val()));
            n2 += this.checkTheValue(parseInt($('#transaction-n-2').val()));
            n3 += this.checkTheValue(parseInt($('#transaction-n-3').val()));
        }

        if ($('#location').is(':checked')) {
            n1 +=this.checkTheValue( parseInt($('#location-n-1').val()));
            n2 +=this.checkTheValue( parseInt($('#location-n-2').val()));
            n3 +=this.checkTheValue( parseInt($('#location-n-3').val()));
        }

        if ($('#gestion').is(':checked')) {

            n1 += this.checkTheValue(parseInt($('#gestion-n-1').val()));
            n2 += this.checkTheValue(parseInt($('#gestion-n-2').val()));
            n3 +=this.checkTheValue( parseInt($('#gestion-n-3').val()));
        }
        if ($('#syndic').is(':checked')) {
            n1 += this.checkTheValue(parseInt($('#syndic-n-1').val()));
            n2 += this.checkTheValue(parseInt($('#syndic-n-2').val()));
            n3 += this.checkTheValue(parseInt($('#syndic-n-3').val()));
        }


        if (n1 == 0 || isNaN(n1)) {
            $('#global-n-1').val('');

        } else {
            $('#global-n-1').val(n1);
        }

        if (n2 == 0 || isNaN(n2)) {
            $('#global-n-2').val('');

        } else {
            $('#global-n-2').val(n2);
        }

        if (n3 == 0 || isNaN(n3)) {
            $('#global-n-3').val('');

        } else {
            $('#global-n-3').val(n3);
        }

    }

    // verifie si la valeur est NAN ou pas
    checkTheValue(data){

        if(isNaN(data)){
            return 0;
        }else{
           return data;
        }

    }

}